export default __webpack_public_path__ + "static/india-b1e3fcbf4c711644fe2f857601405901.svg";